import styled, { css } from "vue-styled-components";

export const AppSpinnerProps = {
  variant: {
    type: String,
    default: "primary",
    validator: (value) => ["primary", "light"].includes(value),
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["md"].includes(value),
  },
};

const sizes = {
  sm: () => css`
    width: 24px;
    height: 24px;
  `,
  md: () => css`
    width: 36px;
    height: 36px;
  `,
};

const variants = {
  primary: ({ colors }) => css`
    border-top-color: ${colors.brand.primary};
    border-left-color: ${colors.brand.primary};
    border-right-color: ${colors.brand.primary};
  `,
  light: ({ colors }) => css`
    border-top-color: ${colors.neutral.gray2};
    border-left-color: ${colors.neutral.gray2};
    border-right-color: ${colors.neutral.gray2};
  `,
};

export const SWrapper = styled("div", AppSpinnerProps)`
  ${({ theme, variant, size }) => css`
    margin: 0;
    padding: 0;
    position: relative;
    border: 2px solid ${theme.colors.neutral.white};
    border-radius: 50%;
    animation: spin 0.75s linear infinite;

    ${size && sizes[size]}
    ${variant && variants[variant](theme)}

      @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `}
`;